export {
  AuthorHero,
  type AuthorHeroProps,
  type AuthorHeroWithSEOProps as AuthorHeroPropsWithSEO,
} from "./AuthorHero";
